import { trigger, transition, animate, style, keyframes } from "@angular/animations";

export let fade=trigger('fade',[
        transition('void=>*',[
          style({transform:'translateX(100%)'}),
          animate('0.8s ease-out',style({transform:'translateX(0px)'}))
    
        ])                                                   
])
export let slide=trigger('slide',[
    transition('void=>*',[  style({transform:'translateX(-100%)'}),
    animate('0.8s ease-out',style({transform:'translateX(0px)'}))]
  )
])
export let down=trigger('down',[
    transition('void=>*',[  style({transform:'translateY(-100%)'}),
    animate('0.8s ease-out',style({transform:'translateY(0px)'}))]
  )
])

export let bounceIn=animate('.8s ease-out',keyframes([
    style({
        offset:0,opacity:0,
        transform:'translateY(-100%)'
    }),
    style({
        offset:.3,opacity:.3,
        transform:'translateY(100%)'
    }),
    style({
        offset:.5,opacity:.5,
        transform:'translateY(2px)'
    }),
    style({
        offset:.7,opacity:.7,
        transform:'translateY(-3px)'
    }),
    style({
        offset:1,opacity:1,
        transform:'translateY(1px)'
    })
    
]))
export let bounceInX=animate('.7s ease-out',keyframes([
    style({
        offset:0,
        opacity:0,
        transform:'translateX(-30%)'
    }),
    style({
        offset:.1,
        opacity:.3,
        transform:'translateX(30%)'
    }),
    style({
        offset:.6,opacity:.6,
        transform:'translateX(2px)'
    }),
    style({
        offset:.9,opacity:.9,
        transform:'translateX(-4px)'
    }),
    style({
        offset:1,opacity:1,
        transform:'translateX(2px)'
    })
    
]))

export let bounceOut=animate('.5s ease-out',keyframes([
    style({
        offset:.2,
        transform:'translateX(10px)'
    }),
    style({
        offset:1,
        transform:'translateX(-100%)'
    }),
  
    
]))



